import { timeMeasureSystem } from 'components/context/TimeMeasureSystem'
import { formatTotalTime, parseTotalEngagement } from 'components/page/utils'
import { useEffect, useState } from 'react'
import { User } from 'types'
import { getFromLocalStorage, USER_DATA } from 'utils'

export function useShowTotalEngagement() {
  const [totalTimeText, setTotalTimeText] = useState<string | null>(null)

  useEffect(() => {
    const updateTime = () => {
      const text = timeMeasureSystem.getTotalEngagementText()
      if (text) {
        setTotalTimeText(text)
      }
    }

    updateTime()

    const timerId = setInterval(updateTime, 1000)

    const handleStorage = () => {
      const updatedUser = getFromLocalStorage(USER_DATA) as User | null
      const updatedTotalTime = parseTotalEngagement(updatedUser?.totalEngagement)
      if (updatedTotalTime) {
        setTotalTimeText(formatTotalTime(updatedTotalTime))
      }
    }

    window.addEventListener('storage', handleStorage)

    return () => {
      clearInterval(timerId)
      window.removeEventListener('storage', handleStorage)
    }
  }, [])

  return { totalTimeText }
}
